export default __webpack_public_path__ + "e82505053a704911e6b919cadaf96431.svg";